import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import app from 'general/js/app';
import { favoritePlayerService } from 'general/js/services';
import { SpriteSvg } from 'project/sprite-svg';
import { CountryFlag } from 'project/country-flag';
import { livePlayer, playerSitecoreData } from 'components/live-player';
import { ScoreTotalCell } from 'components/scores';
import { PLAYER_SILHOUETTE_ON_SCORECARD } from 'general/js/constants';
import { groupStatus, playerStatusCodes } from './enums';
import { TEE_TIMES_WIDGET_SCORECARD_TITLE } from '../../live-player/js/enums';

const TeeTimesWidgetCard = (
    {
        model,
        status,
    }
) => {
    const stateCss = classNames({
        'is-inactive': status === groupStatus.INACTIVE,
        'is-active': status === groupStatus.ACTIVE || status === groupStatus.FINISHED,
    });
    const sitecoreData = model.sitecoreData || playerSitecoreData;
    const isWithdrawn = (model.status && model.status > 2) || false;
    const playerStatuses = app.state.playerStatuses || [];
    const photoCss = classNames({ 'is-withdrawn': isWithdrawn });
    const isFavourite = favoritePlayerService.isFavourite(model.id);
    const playerCutOutSrc = sitecoreData.cutoutSrc || PLAYER_SILHOUETTE_ON_SCORECARD;
    const getPlayerStatusText = (statusId) => {
        const foundPlayerStatus = playerStatuses.find((playerStatus) =>
            playerStatus.id === statusId);
        return (foundPlayerStatus && foundPlayerStatus.text) || '';
    };

    return (
        <div className={`tee-times-widget-card ${stateCss}`} onClick={() => livePlayer.show(model.id, TEE_TIMES_WIDGET_SCORECARD_TITLE + sitecoreData.firstName + ' ' + sitecoreData.lastName)}>
            <div className="tee-times-widget-card__title">
                {
                    sitecoreData.firstName &&
                    <div className="tee-times-widget-card__firstname">{sitecoreData.firstName}</div>
                }
                {
                    sitecoreData.lastName &&
                    <div className={'tee-times-widget-card__lastname'}>
                        <span>{sitecoreData.lastName}</span>
                        {sitecoreData.isAmateur && <span className="tee-times-widget-card__amateur">&nbsp;(a)</span>}
                        &nbsp;
                        <SpriteSvg iconName={'chevron-right'} width="8" height="8" />
                    </div>
                }
            </div>
            <CountryFlag childCss={'tee-times-widget-card__flag'} image={sitecoreData.countryFlagSrc} />
            {
                model.par ?
                    <ScoreTotalCell childCss={'tee-times-widget-card__score'} par={model.par} /> :
                    <div className="tee-times-widget-card__score"></div>
            }
            {
                isFavourite &&
                <div className="tee-times-widget-card__favourite">
                    <svg className="icon" width="12" height="12" focusable="false">
                        <use xlinkHref="#icon-star"></use>
                    </svg>
                </div>
            }

            <div className={`tee-times-widget-card__photo ${photoCss}`}>
                {
                    playerCutOutSrc &&
                    <img className="lazyload" data-srcset={playerCutOutSrc} alt="" />
                }
            </div>
            {
                model.status !== playerStatusCodes.ACTIVE &&
                <div className='tee-times-widget-card__withdrawn'>{getPlayerStatusText(model.status)}</div>
            }
        </div>
    );
};

TeeTimesWidgetCard.propTypes = {
    model: PropTypes.object.isRequired,
    status: PropTypes.number,
};

export default TeeTimesWidgetCard;
